import React, { Component } from 'react';
import { reduxForm } from 'redux-form';

import { WAREHOUSE_KITCHEN_AVAILABILITY_FORM_NAME } from 'Common/FormEnum';
import WarehouseAvailabilityComponent from './../components/WarehouseAvailability';

class WarehouseAvailabilityContainer extends Component {
  state = { activeIndexes: [0, 1] };

  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const cloneActiveIndexes = [...this.state.activeIndexes];
    cloneActiveIndexes.indexOf(index) !== -1
      ? cloneActiveIndexes.splice(cloneActiveIndexes.indexOf(index), 1)
      : cloneActiveIndexes.push(index);
    this.setState({ activeIndexes: cloneActiveIndexes });
  };

  render() {
    const { printLoading, onPrintClick } = this.props;
    return (
      <WarehouseAvailabilityComponent
        printLoading={printLoading}
        activeIndexes={this.state.activeIndexes}
        onPrintClick={onPrintClick}
        handleCollapsePanelClick={this.handleCollapsePanelClick}
      />
    );
  }
}
export const WarehouseAvailability = reduxForm({
  form: WAREHOUSE_KITCHEN_AVAILABILITY_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(WarehouseAvailabilityContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousereport/containers/WarehouseAvailability.js